import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useWeb3 } from '../../context/Web3Context';
import { formatAddress } from '../../utils/helpers';

// V6: Notification via PHP endpoint (no contract call)
const NOTIFICATION_API = 'https://richfactory.org/api/notification.php';

export default function Header() {
  const { account, userId } = useWeb3();
  const [notif, setNotif] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (!account) return;
    (async () => {
      try {
        const res = await fetch(NOTIFICATION_API + '?t=' + Date.now());
        const n = await res.json();
        if (n.text && n.text.length > 0) {
          setNotif({ text: n.text, image: n.image, ts: n.timestamp });
        }
      } catch {}
    })();
  }, [account]);

  const hasNotif = notif && notif.text.length > 0;

  return (
    <>
      <motion.header className="header" initial={{ y: -50, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ type: 'spring', stiffness: 200, damping: 25 }}>
        <div className="h-left">
          <img src="/logo.png" alt="RF" />
          <span className="h-brand">RICH FACTORY</span>
        </div>
        <div className="h-right">
          {account && <>
            {hasNotif && (
              <motion.div
                onClick={() => setShowPopup(true)}
                style={{ position: 'relative', cursor: 'pointer', marginRight: 6 }}
                whileTap={{ scale: 0.9 }}
                initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.4, type: 'spring' }}
              >
                <span style={{ fontSize: '1.2rem' }}>🔔</span>
                <motion.span style={{
                  position: 'absolute', top: -4, right: -6,
                  background: '#FF3D00', color: '#fff', fontSize: '0.55rem', fontWeight: 800,
                  width: 16, height: 16, borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontFamily: 'var(--font-m)'
                }} animate={{ scale: [1, 1.2, 1] }} transition={{ duration: 2, repeat: Infinity }}>1</motion.span>
              </motion.div>
            )}
            {userId && <motion.span className="h-id" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.3, type: 'spring' }}>#{userId}</motion.span>}
            <span className="h-addr">{formatAddress(account)}</span>
            <span className="h-dot" />
          </>}
        </div>
      </motion.header>

      {/* Notification Popup */}
      <AnimatePresence>
        {showPopup && notif && (
          <motion.div
            style={{
              position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
              background: 'rgba(0,0,0,0.85)', zIndex: 10000,
              display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20
            }}
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={() => setShowPopup(false)}
          >
            <motion.div
              style={{
                background: 'linear-gradient(145deg,#1a1a2e,#16213e)',
                border: '1px solid rgba(255,215,0,0.3)', borderRadius: 20,
                padding: 28, maxWidth: 420, width: '100%', textAlign: 'center', position: 'relative'
              }}
              initial={{ scale: 0.5, y: 50 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.5, y: 50 }}
              transition={{ type: 'spring', bounce: 0.3 }}
              onClick={e => e.stopPropagation()}
            >
              <div style={{ fontSize: '2rem', marginBottom: 12 }}>📢</div>
              <div style={{
                fontFamily: 'var(--font-h)', fontSize: '0.75rem', color: 'var(--gold)',
                textTransform: 'uppercase', letterSpacing: '2px', marginBottom: 14
              }}>Announcement</div>
              {notif.image && (
                <img src={notif.image} alt="" style={{
                  maxWidth: '100%', maxHeight: 200, borderRadius: 12,
                  marginBottom: 16, objectFit: 'cover'
                }} />
              )}
              <div style={{
                fontSize: '0.95rem', color: '#fff', lineHeight: 1.7,
                marginBottom: 20, whiteSpace: 'pre-wrap'
              }}>{notif.text}</div>
              <motion.button
                style={{
                  background: 'linear-gradient(135deg,#FFD700,#F0A500)', border: 'none',
                  borderRadius: 12, padding: '12px 40px', fontFamily: 'var(--font-m)',
                  fontWeight: 700, fontSize: '0.95rem', color: '#000', cursor: 'pointer'
                }}
                onClick={() => setShowPopup(false)}
                whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}
              >Close</motion.button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
